import { JobProps, JobStatus } from 'common/types'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useTheme } from 'styled-components'
import { AlertApplyBox, JobDetailsApplyBox } from '../styled'
import moment from 'moment'
import { Button } from 'common/atoms/Button/Button'

export interface IJobApplyButtonProps {
  alreadyApplied: boolean
  handleJobApply: Function
  job: JobProps
  showAlertBox?: boolean
}

const JobApplyButton = (props: IJobApplyButtonProps) => {
  const { alreadyApplied, handleJobApply, job, showAlertBox } = props
  const { isDevice } = useScreenSizes()
  const id = `topApplyButton-${Date.now()}`
  const applied =
    alreadyApplied ||
    job?.isApplyDisabled === true

  const jobExpired = moment(job?.expiryDate) < moment(Date.now()) ||
  job?.status === JobStatus.CLOSED

  let buttonLabel = 'Apply Now'

  if (jobExpired) buttonLabel = 'Not Accepting Applicants'
  // Take note, the below if statement needs to be after the above if statement. 'Cause if a user had previously applied for a job and the job expires, the button will say "No Accepting Applicants".
  if (applied) buttonLabel = 'Applied'

  return (
    <>
      <AlertApplyBox zIndex={2} width="100%">
        <JobDetailsApplyBox isDevice={isDevice} showAlertBox={showAlertBox}>
          <Button
            design="primary"
            forwardArrowIcon={!applied && !jobExpired}
            id={id}
            fullWidth
            onClick={event => handleJobApply(event)}
            disabled={jobExpired || applied}
          >
            {buttonLabel}
          </Button>
        </JobDetailsApplyBox>
      </AlertApplyBox>
    </>
  )
}

export default JobApplyButton
